import { IntlProvider } from "react-intl"
import PropTypes from 'prop-types';
import React, { Component, Children } from "react";
import State from "../stores/State"

export class LanguageProvider extends Component {
  state = { locale: State.get("locale") }

  componentDidMount() {
    this._stateListener = State.addListener(() => {
      // console.log("in state listener")
      if (State.get("locale") !== this.state.locale) {
        // console.log("updating component state")
        this.setState({ locale: State.get("locale") })
      }
    })
  }

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
  }

  render() {
    const { locale } = this.state
    return (
      <IntlProvider
        locale={locale}
        key={locale}
        messages={this.props.messages[locale]}
      >
        {Children.only(this.props.children)}
      </IntlProvider>
    )
  }
}

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.element.isRequired
}



// WEBPACK FOOTER //
// ./webapp/components/LanguageProvider.js